import * as React from 'react'
import ReactHtmlParser from 'react-html-parser';
import { timestampToLongDate } from 'src/share/utils/utils';

const handleImageError = (evt) => {
   evt.target.onerror = null;
   evt.target.style.display = "none";
 };

const NewsCard = ({ isAdmin, article, refElement, onRemove }) => {
  return (
    <div className="news-card white-background" ref={refElement}>
      {article.imageURL && <img className="news-card__image" src={article.imageURL} alt="News Article Image" onError={handleImageError}/>}
      <div className="news-card__info">
        <h5 className="news-card__title">{ReactHtmlParser(article.title)}</h5>
        <span className="news-card__details">{article.source} - {timestampToLongDate(article.publishedAt)}</span>
        <p className="news-card__description">
          {ReactHtmlParser(article.description)}
        </p>
        <div className="news-card__actions">
          <button className="read-more" onClick={() => window.open(article.url)}>Read more <span className="fa fa-long-arrow-right" aria-hidden="true"/></button>
          {isAdmin && <button className="discard" onClick={() => onRemove(article.id)}><span className="fa fa-trash-o" aria-hidden="true"/></button>}
        </div>
      </div>
    </div>
  )
}

export default NewsCard;
